// extracted by mini-css-extract-plugin
module.exports = {"list-layout-full-height-background":"_5Mrtw","listLayoutFullHeightBackground":"_5Mrtw"};